const mixin = {
  data() {
    return {
      cloudSmsStatus: [{
          label: '草稿',
          value: 1
        },
        {
          label: '已发送',
          value: 2
        }
      ],
      userGroupsType: [{
          label: '红会个人会员',
          value: 3
        },
        {
          label: '红会团体会员',
          value: 2
        },
        {
          label: '捐赠者',
          value: 6
        },
        {
          label: '志愿者',
          value: 7
        },
        {
          label: '造血干细胞捐献者',
          value: 8
        },
        {
          label: '遗体捐献者',
          value: 9
        },
        {
          label: '其他账号',
          value: 5
        },
      ],
      lectureApplyStatus: [{
          label: '待审核',
          value: 0
        },
        {
          label: '通过',
          value: 1
        },
        {
          label: '不通过',
          value: 2
        }
      ],
      idType: [{
          label: '身份证',
          value: 0
        },
        {
          label: '其他',
          value: 1
        }
      ],
      national: [{
          label: '汉族',
          value: 0
        },
        {
          label: '其他',
          value: 1
        }
      ],
      relationCode: [{
          label: '父母',
          value: '01'
        },
        {
          label: '配偶',
          value: '02'
        },
        {
          label: '子女',
          value: '03'
        },
        {
          label: '兄弟姐妹',
          value: '04'
        },
        {
          label: '其他亲属',
          value: '05'
        },
        {
          label: '朋友',
          value: '06'
        }
      ],
      political: [{
          label: '中共党员',
          value: 0
        },
        {
          label: '共青团员',
          value: 1
        },
        {
          label: '民主党派',
          value: 2
        },
        {
          label: '无党派人士',
          value: 3
        },
        {
          label: '群众',
          value: 4
        }
      ],
      bloodType: [{
          label: 'A型',
          value: 'A型'
        },
        {
          label: 'B型',
          value: 'B型'
        },
        {
          label: 'AB型',
          value: 'AB型'
        },
        {
          label: 'O型',
          value: 'O型'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      NativePlace: [{
          label: '北京市',
          value: '北京市'
        },
        {
          label: '上海市',
          value: '上海市'
        },
        {
          label: '天津市',
          value: '天津市'
        },
        {
          label: '重庆市',
          value: '重庆市'
        },
        {
          label: '河北省',
          value: '河北省'
        },
        {
          label: '山西省',
          value: '山西省'
        },
        {
          label: '内蒙古省',
          value: '内蒙古省'
        },
        {
          label: '辽宁省',
          value: '辽宁省'
        },
        {
          label: '吉林省',
          value: '吉林省'
        },
        {
          label: '黑龙江省',
          value: '黑龙江省'
        },
        {
          label: '江苏省',
          value: '江苏省'
        },
        {
          label: '浙江省',
          value: '浙江省'
        },
        {
          label: '安徽省',
          value: '安徽省'
        },
        {
          label: '福建省',
          value: '福建省'
        },
        {
          label: '江西省',
          value: '江西省'
        },
        {
          label: '山东省',
          value: '山东省'
        },
        {
          label: '河南省',
          value: '河南省'
        },
        {
          label: '湖北省',
          value: '湖北省'
        },
        {
          label: '湖南省',
          value: '湖南省'
        },
        {
          label: '广东省',
          value: '广东省'
        },
        {
          label: '广西省',
          value: '广西省'
        },
        {
          label: '海南省',
          value: '海南省'
        },
        {
          label: '四川省',
          value: '四川省'
        },
        {
          label: '贵州省',
          value: '贵州省'
        },
        {
          label: '云南省',
          value: '云南省'
        },
        {
          label: '西藏省',
          value: '西藏省'
        },
        {
          label: '陕西省',
          value: '陕西省'
        },
        {
          label: '甘肃省',
          value: '甘肃省'
        },
        {
          label: '宁夏省',
          value: '宁夏省'
        },
        {
          label: '青海省',
          value: '青海省'
        },
        {
          label: '新疆省',
          value: '新疆省'
        },
        {
          label: '香港',
          value: '香港'
        },
        {
          label: '澳门',
          value: '澳门'
        },
        {
          label: '台湾省',
          value: '台湾省'
        }
      ],
      Nation: [{
          label: '汉族',
          value: '汉族'
        },
        {
          label: '蒙古族',
          value: '蒙古族'
        },
        {
          label: '回族',
          value: '回族'
        },
        {
          label: '藏族',
          value: '藏族'
        },
        {
          label: '维吾尔族',
          value: '维吾尔族'
        },
        {
          label: '苗族',
          value: '苗族'
        },
        {
          label: '彝族',
          value: '彝族'
        },
        {
          label: '壮族',
          value: '壮族'
        },
        {
          label: '布依族',
          value: '布依族'
        },
        {
          label: '朝鲜族',
          value: '朝鲜族'
        },
        {
          label: '满族',
          value: '满族'
        },
        {
          label: '瑶族',
          value: '瑶族'
        },
        {
          label: '白族',
          value: '白族'
        },
        {
          label: '土家族',
          value: '土家族'
        },
        {
          label: '哈尼族',
          value: '哈尼族'
        },
        {
          label: '哈萨克族',
          value: '哈萨克族'
        },
        {
          label: '傣族',
          value: '傣族'
        },
        {
          label: '黎族',
          value: '黎族'
        },
        {
          label: '傈僳族',
          value: '傈僳族'
        },
        {
          label: '佤族',
          value: '佤族'
        },
        {
          label: '畲族',
          value: '畲族'
        },
        {
          label: '高山族',
          value: '高山族'
        },
        {
          label: '拉祜族',
          value: '拉祜族'
        },
        {
          label: '水族',
          value: '水族'
        },
        {
          label: '东乡族',
          value: '东乡族'
        },
        {
          label: '纳西族',
          value: '纳西族'
        },
        {
          label: '景颇族',
          value: '景颇族'
        },
        {
          label: '柯尔克孜族',
          value: '柯尔克孜族'
        },
        {
          label: '土族',
          value: '土族'
        },
        {
          label: '达斡尔族',
          value: '达斡尔族'
        },
        {
          label: '仫佬族',
          value: '仫佬族'
        },
        {
          label: '羌族',
          value: '羌族'
        },
        {
          label: '布朗族',
          value: '布朗族'
        },
        {
          label: '撒拉族',
          value: '撒拉族'
        },
        {
          label: '毛南族',
          value: '毛南族'
        },
        {
          label: '仡佬族',
          value: '仡佬族'
        },
        {
          label: '锡伯族',
          value: '锡伯族'
        },
        {
          label: '阿昌族',
          value: '阿昌族'
        },
        {
          label: '普米族',
          value: '普米族'
        },
        {
          label: '塔吉克族',
          value: '塔吉克族'
        },
        {
          label: '怒族',
          value: '怒族'
        },
        {
          label: '乌孜别克族',
          value: '乌孜别克族'
        },
        {
          label: '俄罗斯族',
          value: '俄罗斯族'
        },
        {
          label: '鄂温克族',
          value: '鄂温克族'
        },
        {
          label: '德昂族',
          value: '德昂族'
        },
        {
          label: '保安族',
          value: '保安族'
        },
        {
          label: '裕固族',
          value: '裕固族'
        },
        {
          label: '京族',
          value: '京族'
        },
        {
          label: '塔塔尔族',
          value: '塔塔尔族'
        },
        {
          label: '独龙族',
          value: '独龙族'
        },
        {
          label: '鄂伦春族',
          value: '鄂伦春族'
        },
        {
          label: '赫哲族',
          value: '赫哲族'
        },
        {
          label: '门巴族',
          value: '门巴族'
        },
        {
          label: '珞巴族',
          value: '珞巴族'
        },
        {
          label: '基诺族',
          value: '基诺族'
        }
      ],

      StemEducation: [{
          label: '初中',
          value: '初中'
        },
        {
          label: '高中',
          value: '高中'
        },
        {
          label: '大专',
          value: '大专'
        },
        {
          label: '本科',
          value: '本科'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      professional: [{
          label: '行政管理人员',
          value: 0
        },
        {
          label: '卫生专业技术人员',
          value: 1
        },
        {
          label: '教学人员',
          value: 2
        },
        {
          label: '安全保卫和消防人员',
          value: 3
        },
        {
          label: '运输服务人员',
          value: 4
        },
        {
          label: '社会服务和居民生活服务人员',
          value: 5
        },
        {
          label: '生产人员',
          value: 6
        },
        {
          label: '其他',
          value: 7
        }
      ],
      volunteerRecruitState: [{
          label: '审核中',
          value: 1
        },
        {
          label: '已发布',
          value: 2
        },
        {
          label: '已审核',
          value: 3
        },
        {
          label: '草稿',
          value: 4
        },
      ],
      //救护员培训考核状态
      checkStatus: [{
          label: '未考核',
          value: 0
        },
        {
          label: '已通过',
          value: 1
        },
        {
          label: '未通过',
          value: 2
        },
      ],
      //个人情况
      personalInfo: [{
          label: '单亲',
          value: 1
        },
        {
          label: '残疾',
          value: 2
        },
        {
          label: '红十字志愿者',
          value: 3
        },
      ],
      //拨款状态
      seekHelpApplyStatue: [{
          label: '待确认',
          value: 1
        },
        {
          label: '已确认',
          value: 2
        },
        {
          label: '结束',
          value: 3
        },
      ],
      //会员等级
      memberLevel: [{
          label: '普通会员',
          value: 0
        },
        {
          label: '特殊会员',
          value: 1
        },
        {
          label: '永久会员',
          value: 2
        },
      ],
      education: [{
          label: '小学',
          value: 0
        },
        {
          label: '初中',
          value: 1
        },
        {
          label: '高中/职高',
          value: 2
        },
        {
          label: '专科',
          value: 3
        },
        {
          label: '本科',
          value: 4
        },
        {
          label: '研究生',
          value: 5
        },
        {
          label: '博士',
          value: 6
        },
        {
          label: '其他',
          value: 7
        }
      ],
      identityAttr: [{
          label: '机关',
          value: 0
        },
        {
          label: '企、事业单位',
          value: 1
        },
        {
          label: '群众',
          value: 2
        },
        {
          label: '学生',
          value: 3
        }
      ],
    }
  }
}
export default mixin